module.exports = __webpack_public_path__ + "img/loading.b7a14906.gif";